import { Outlet } from 'react-router';
import { RoutesConfig } from 'shell/router/routes-config';
import { NotFound } from 'shell/error/components/error-not-found';
import TypeDocInitializer from 'front-office/pages/type-doc';
import TypeDocList from 'front-office/pages/type-doc/list';
import TypeDocDetail from 'front-office/pages/type-doc/detail';
import TypeDocEdit from 'front-office/pages/type-doc/edit';
import TypeDocNew from 'front-office/pages/type-doc/new';
import ReleaseModeInitializer from 'front-office/pages/release-mode';
import ReleaseModeList from 'front-office/pages/release-mode/list';
import ReleaseModeDetail from 'front-office/pages/release-mode/detail';
import ReleaseModeEdit from 'front-office/pages/release-mode/edit';
import ReleaseModeNew from 'front-office/pages/release-mode/new';
import RegisterCertificationInitializer from 'front-office/pages/register-certification';
import RegisterCertificationPage from 'front-office/pages/register-certification/list';
import RegisterCertificationDetail from 'front-office/pages/register-certification/detail';
import RegisterCertificationEdit from 'front-office/pages/register-certification/edit';
import RegisterCertificationNew from 'front-office/pages/register-certification/new';
import {
  FrontOfficeAuthorizations,
  TypeDocAuthorizations,
  ReleaseModeAuthorizations,
  RegisterCertificationAuthorizations,
} from 'shell/authorizations/front-office';

export const TableServiceRoutes: RoutesConfig = [
  {
    name: 'Tabelle di servizio',
    path: '',
    element: <Outlet />,
    hidden: true,
    children: [
      {
        path: '',
        hidden: true,
      },
      {
        path: '/tipo-doc',
        name: 'Tipo documento',
        authorizations: TypeDocAuthorizations,
        element: <TypeDocInitializer />,
        children: [
          {
            path: '',
            element: <TypeDocList />,
          },
          {
            path: '/dettaglio/:id/:idDoc',
            element: <TypeDocDetail />,
            authorizations: [FrontOfficeAuthorizations.TipoDocQuery],
          },
          {
            path: '/modifica/:id/:idDoc',
            element: <TypeDocEdit />,
            authorizations: [FrontOfficeAuthorizations.TipoDocUpdate],
          },
          {
            path: '/nuovo',
            element: <TypeDocNew />,
            authorizations: [FrontOfficeAuthorizations.TipoDocAdd],
          },
        ],
      },
      {
        path: '/modalita-rilascio',
        element: <ReleaseModeInitializer />,
        name: 'Modalità rilascio',
        authorizations: ReleaseModeAuthorizations,
        children: [
          {
            path: '',
            element: <ReleaseModeList />,
          },
          {
            path: '/dettaglio/:id',
            element: <ReleaseModeDetail />,
            authorizations: [FrontOfficeAuthorizations.TipoRilascioQuery],
          },
          {
            path: '/modifica/:id',
            element: <ReleaseModeEdit />,
            authorizations: [FrontOfficeAuthorizations.TipoRilascioUpdate],
          },
          {
            path: '/nuovo',
            element: <ReleaseModeNew />,
            authorizations: [FrontOfficeAuthorizations.TipoRilascioAdd],
          },
        ],
      },
      {
        path: '/ricerca-registro',
        name: 'Ricerca Registro',
        authorizations: RegisterCertificationAuthorizations,
        element: <RegisterCertificationInitializer />,
        children: [
          {
            path: '',
            element: <RegisterCertificationPage />,
          },
          {
            path: '/dettaglio/:id/:institution',
            element: <RegisterCertificationDetail />,
            authorizations: [FrontOfficeAuthorizations.CertificazioneRegistroQuery],
          },
          {
            path: '/modifica/:id/:institution',
            element: <RegisterCertificationEdit />,
            authorizations: [FrontOfficeAuthorizations.CertificazioneRegistroUpdate],
          },
          {
            path: '/nuovo',
            element: <RegisterCertificationNew />,
            authorizations: [FrontOfficeAuthorizations.CertificazioneRegistroAdd],
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
